<template>
  <v-sheet>
    <header-menu-section
      :subheader="menu.mainSubheader"
      :overview="menu.overviewLink"
    >
      <template
        v-for="link in menu.mainLinks"
        :key="link._uid"
      >
        <header-menu-link v-bind="link" />
      </template>
    </header-menu-section>

    <template v-if="menu.optionalLinks.length">
      <header-menu-section
        bg-color="black-4"
        :subheader="menu.optionalSubheader"
      >
        <template
          v-for="link in menu.optionalLinks"
          :key="link._uid"
        >
          <header-menu-link v-bind="link" />
        </template>

        <template #actions>
          <orange-btn
            v-bind="menu.cta"
            variant="outlined"
            height="36"
            color="#FF4E00"
            class="text-body-xs font-bold"
          />
        </template>
      </header-menu-section>
    </template>
  </v-sheet>
</template>

<script setup lang="ts">
const definedProps = defineProps<{
  menu: {
    mainSubheader?: string
    optionalSubheader?: string
    mainLinks: {
      _uid: string
      title: string
      [key: string]: string
    }[]
    optionalLinks: {
      _uid: string
      title: string
      [key: string]: string
    }[]
    overviewLink?: {
      title: string
      [key: string]: string
    }
    cta: {
      title: string
      [key: string]: string
    }
  }
}>()

useDefaults(definedProps, 'HeaderMenu')
</script>
